import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

// Component that fetches and displays arena data in tabs
const TabView = ({ tab, activeTab, handleTabSelect }) => {
	return (
		<>
			{/* Displaying arena data in tabs */}
			<Tabs
				className={"container-fluid year-planner-tab"}
				onSelect={handleTabSelect}
				defaultActiveKey={activeTab}
			>
				{tab.map((value, index) => {
					return (
						<Tab
							key={index + 1}
							eventKey={index + 1}
							title={value.name}
						></Tab>
					);
				})}
			</Tabs>
		</>
	);
};

export default TabView;
